import { useDeleteGroup } from "http-hooks/partysupmast/usepartysupmast";
import DeleteConfirmation from "components/ui/DeleteConfirmation";

export default function DeleteGroup({ id, onClose }) {
  const { mutateAsync, isPending } = useDeleteGroup();

  const handleDelete = async () => {
    try {
      await mutateAsync(id);
      onClose();
    } catch (error) {
      // Error toast already shown by service
      console.error("Delete failed:", error);
    }
  };

  return (
    <DeleteConfirmation
      title="Delete Group"
      description="Are you sure you want to delete this group? This group will be permanently removed. This action cannot be undone."
      onDelete={handleDelete}
      onClose={onClose}
      isLoading={isPending}
    />
  );
} 